// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  margin: 0;
}
.grid.filters {
  grid-template-columns: repeat(5, 1fr);
}
.grid.clients {
  grid-template-columns: repeat(9, auto);
}
.grid.clients > div:nth-child(18n+10),
.grid.clients > div:nth-child(18n+11),
.grid.clients > div:nth-child(18n+12),
.grid.clients > div:nth-child(18n+13),
.grid.clients > div:nth-child(18n+14),
.grid.clients > div:nth-child(18n+15),
.grid.clients > div:nth-child(18n+16),
.grid.clients > div:nth-child(18n+17),
.grid.clients > div:nth-child(18n+18) {
  background-color: rgba(245, 245, 245, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/app/clients-module/clients-list/clients.component.less"],"names":[],"mappings":"AAEA;EACI,SAAA;AADJ;AAGA;EACI,qCAAA;AADJ;AAGA;EACI,sCAAA;AADJ;AAGA;;;;;;;;;EASE,0CAAA;AADF","sourcesContent":["@import (reference) url(\"../../../styles.less\");\n\nh1 {\n    margin: 0;\n}\n.grid.filters {\n    grid-template-columns: repeat(5, 1fr);\n}\n.grid.clients {\n    grid-template-columns: repeat(9, auto);\n}\n.grid.clients > div:nth-child(18n+10),\n.grid.clients > div:nth-child(18n+11),\n.grid.clients > div:nth-child(18n+12),\n.grid.clients > div:nth-child(18n+13),\n.grid.clients > div:nth-child(18n+14),\n.grid.clients > div:nth-child(18n+15),\n.grid.clients > div:nth-child(18n+16),\n.grid.clients > div:nth-child(18n+17),\n.grid.clients > div:nth-child(18n+18) {\n  background-color: @grid-row;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
